<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-48 px-4 overflow-hidden">
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Lista de eventos
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
          >{{filteredEvents.length}}</span>
        </h3>
        <button class="border-2 rounded border-gray-700" @click="changeFormOrder">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
        <div
          class="rounded-full cursor-pointer bg-primary-color hover:bg-primary-color-dark p-1 ml-2"
          @click="openAddModal()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current text-white h-6 w-6"
            viewBox="0 0 24 24"
          >
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
        <div
          class="rounded-full cursor-pointer bg-secondary-color hover:bg-secondary-color-dark p-2 ml-2"
          @click="openCalendar()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current text-white h-4 w-4"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de eventos"
        class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />

      <div class="w-full">
        <div class="w-full relative mb-2">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
          >
            <option selected value="-1">Todos</option>
            <template v-for="category in eventCategories">
              <option :key="category.id" :value="category.id">{{category.name}}</option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <!-- <div class="w-full flex pt-4 pb-2">
        <button
          class="w-1/3 hover:bg-blue-500 font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-blue-500 hover:border-transparent rounded"
        >Todos</button>
        <button
          class="w-1/3 hover:bg-blue-500 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
        >Activos</button>
        <button
          class="w-1/3 hover:bg-blue-500 font-semibold hover:text-white py-2 px-4 border-t border-r border-b border-blue-500 hover:border-transparent rounded"
        >Inactivos</button>
      </div>-->
      <div class="h-full overflow-auto">
        <div
          v-for="event in filteredEvents"
          :key="event.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{'bg-secondary-color': event.id === currentEvent.id}"
          @click="selectEvent(event)"
        >
          <img :src="event.imagen" class="h-12 w-12 object-cover" @error="loadDefaultImg" />
          <div class="flex flex-col ml-2">
            <span
              :class="[event.id === currentEvent.id ? 'text-gray-100' : 'text-gray-900']"
              class="group-hover:text-gray-900"
            >{{ event.nombre}}</span>
            <span
              :class="[event.id === currentEvent.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >{{ event.lugar }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="w-full pb-2 text-right">
            <button
              v-if="eventComments.length > 0"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="showCommentsModal = true"
            >Ver comentarios</button>
            <button
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="openSendModal(currentEvent.id, currentEvent.nombre)"
            >Enviar a visitantes</button>
            <button
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="openEditModal()"
            >Editar</button>
            <button
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingConfirm = true"
            >Eliminar</button>
          </div>
          <div class="flex w-full">
            <div class="w-4/12">
              <div class="w-full px-4 text-left">
                <div class="font-bold tracking-wide text-lg text-gray-900">{{ currentEvent.nombre }}</div>
                <div
                  class="text-sm text-gray-800 pt-2 text-right"
                >Inicio: {{ currentEvent.fecha | moment('DD/MM/YYYY') }} &ndash; {{ currentEvent.hora }}</div>
                <div
                  class="text-sm text-gray-800 pt-2 text-right"
                >Fin: {{ currentEvent.fecha_final | moment('DD/MM/YYYY') }} &ndash; {{ currentEvent.hora_final }}</div>
                <div class="text-sm text-gray-700">{{ currentEvent.descripcion }}</div>
                <div class="text-sm text-gray-700" v-if="currentEvent.url !== null && currentEvent.url !== ''">
                  <a :href="currentEvent.url" target="_blank" class="underline text-blue-600">Enlace externo</a>
                </div>
              </div>
            </div>
            <div class="w-8/12">
              <div class="text-left font-bold text-sm text-gray-700">Ubicación:</div>
              <div class="flex">
                <div class="h-80 w-full">
                  <l-map
                    ref="map"
                    class="h-full w-full z-0"
                    :zoom="zoom"
                    :minZoom="11"
                    :center="center"
                    :options="{zoomControl: false}"
                    @ready="onMapReady"
                  >
                    <l-geo-json :geojson="polygon" :options-style="geoStyle" />
                    <l-geo-json :geojson="geojsonRouter" />
                    <l-marker :lat-lng="center" :visible="showMarker"></l-marker>
                  </l-map>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-center w-full">
            <div class="w-full my-2 text-lg uppercase font-bold tracking-wider">Imagen del evento</div>
            <img :src="currentEvent.imagen" />
          </div>
          <div v-if="currentEvent.imagen2 !== null" class="flex flex-wrap items-center justify-center w-full">
            <div class="w-full my-2 text-lg uppercase font-bold tracking-wider">Imagen secundaria</div>
            <img :src="currentEvent.imagen2" />
          </div>
        </div>
      </div>
    </div>
    <event-modal
      :showing="showEventModal"
      :event="modalEvent"
      :aux_event="aux_modalEvent"
      :modalAction="modalAction"
      @close="closeModal"
    ></event-modal>

    <event-comments-modal
      :showing="showCommentsModal"
      @close="closeCommentsModal"
      :eventComments="eventComments"
      @updateComments="updateComments"
    ></event-comments-modal>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Evento guardado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea eliminar el evento?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deleteEvent()"
        >Eliminar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Evento eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <send-event-modal :showing="showSendModal" :eventName="eventName" :eventId="eventId" @close="closeSendModal"></send-event-modal>
    <alert-dialog :showing="showingSentDialog">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Evento enviado</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSentDialog = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <event-calendar
      :showing="showingCalendar"
      :colors="colors"
      :events="calendarEvents"
      @close="closeCalendar"
    ></event-calendar>
    <duplicate-events-modal
      :showing="showDuplicateEvents"
      :events="duplicateEvents"
      @close="closeDuplicateEvents"
    ></duplicate-events-modal>
  </div>
</template>

<script>
import EventModal from "./EventModal";
import AlertDialog from "./AlertDialog";
import SendEventModal from "./SendEventModal";
import EventCalendar from "./EventCalendar";
import EventCommentsModal from "./EventCommentsModal";
import DuplicateEventsModal from "./DuplicateEventsModal";
import polygon from "../assets/polygonChapp.json";

import L from "leaflet";
import { LMap, LMarker, LGeoJson } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import "leaflet-kmz/dist/leaflet-kmz";
import "leaflet-kml/L.KML";
import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

import * as palette from "google-palette";

export default {
  name: "events-list",
  data() {
    return {
      geojsonRouter: null,
      eventName: "",
      events: [],
      search: "",
      currentEvent: {},
      showEventModal: false,
      showSendModal: false,
      showingSentDialog: false,
      eventId: null,
      showingSuccess: false,
      showingConfirm: false,
      showingError: false,
      showingSuccessDelete: false,
      modalEvent: {},
      aux_modalEvent: {},
      modalAction: "",
      eventCategories: [],
      categoryFilter: "-1",
      showCommentsModal: false,
      eventComments: [],
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      showingCalendar: false,
      calendarEvents: [],
      showDuplicateEvents: false,
      duplicateEvents: [],
      polygon: polygon,
      zoom: 14,
      center: [19.412257, -99.200871],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      formOrder: "upward",
      leafletMap: null,
      currentRouteLayer: null,
      kmzParser: null,
      layerKml: null,
      colors: []
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    EventModal,
    AlertDialog,
    SendEventModal,
    EventCalendar,
    EventCommentsModal,
    DuplicateEventsModal
  },
  created() {
    let that = this;
/*     this.$socket.$subscribe("updateCategoryConfigToMonitor", () => {
      that.fetchCategories();
      that.fetchEvents();
    }); */
  },
  mounted() {
    this.fetchCategories();
  },
  methods: {
    onMapReady: function() {
      this.$nextTick(() => {
        let that = this;
        const map = this.$refs.map.mapObject;
        esri.basemapLayer("Topographic").addTo(map);
        this.leafletMap = map;

        this.kmzParser = new L.KMZParser({
          onKMZLoaded: function(layer, name) {
            that.geojsonRouter = null;

            if(that.layerKmz != null){
              map.removeLayer(that.layerKmz);
              that.layerKmz = null;
            }

            that.layerKmz = layer;
            layer.addTo(map);
          }
        });
      });
    },
    fetchEvents() {
      this.axios
        .get("apidev/api/events", this.config)
        .then(response => {
          this.events = response.data;
          this.calendarEvents = [];
          this.events.forEach(data => {
            if (this.currentEvent !== {}) {
              if (this.currentEvent.id === data.id) {
                this.currentEvent = data;
              }
            }

            if (data.imagen != null) {
              data.imagen = "apidev/" + data.imagen;
            } else {
              data.imagen = require("@/assets/default-image-sm.jpg");
            }

            if (data.imagen2 != null) {
              data.imagen2 = "apidev/" + data.imagen2;
            }

            let parsedDate = new Date(data.fecha);
            let formattedTime = data.hora.substring(0, 5);

            let formattedDate =
              parsedDate.getFullYear() +
              "-" +
              ("0" + (parsedDate.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + parsedDate.getDate()).slice(-2) +
              " " +
              formattedTime;

            let parsedEndingDate = new Date(data.fecha_final);
            let formattedEndingTime = data.hora_final.substring(0, 5);

            let formattedEndingDate =
              parsedEndingDate.getFullYear() +
              "-" +
              ("0" + (parsedEndingDate.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + parsedEndingDate.getDate()).slice(-2) +
              " " +
              formattedEndingTime;

            let eventStartDate = new Date(formattedDate);
            let eventEndDate = new Date(formattedEndingDate);

            let eventColor = "";
            this.colors.forEach(color => {
              if (color.name === data.name) {
                eventColor = color.color;
              }
            });

            let event = {
              id: data.id,
              title: data.nombre,
              body: data.descripcion,
              category: "time",
              dueDateClass: "",
              start: eventStartDate.toISOString(),
              end: eventEndDate.toISOString(),
              bgColor: "#" + eventColor,
              color: "#ffffff",
              customStyle: `background-color: #${eventColor};`,
              raw: {
                place: data.lugar,
                image: data.imagen
              }
            };

            this.calendarEvents.push(event);
          });

          if (
            Object.keys(this.currentEvent).length === 0 &&
            this.currentEvent.constructor === Object
          ) {
            this.currentEvent = this.filteredEvents[0];
          }

          this.center = [this.currentEvent.lat, this.currentEvent.lng];
          this.showMarker = true;
          this.fetchEventComments(this.currentEvent.id);
          this.showPolygonInMap()
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    showPolygonInMap(){
      if (this.currentEvent.ruta !== null) {
        if(this.currentEvent.kml!=null){
          const type = this.currentEvent.kml.split(".")[1];
          if(type=="kml"){
            this.resetFileGeometryInMap();
            this.geojsonRouter = null;
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", () => {
              this.loadKml(oReq.responseText)
            });
            oReq.open("GET", "apidev/"+this.currentEvent.kml);
            oReq.send();
          }

          if(type=="kmz"){
            this.resetFileGeometryInMap();
            this.kmzParser.load("apidev/"+this.currentEvent.kml)
          }
        }else{
          this.resetFileGeometryInMap();
          this.geojsonRouter = this.currentEvent.ruta;
        }
      } else {
        this.resetFileGeometryInMap();
        this.geojsonRouter = null;
      }

    },
    resetFileGeometryInMap(){
      if(this.layerKmz != null){
        this.leafletMap.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }

      if(this.layerKml != null){
        this.leafletMap.removeLayer(this.layerKml);
        this.layerKml = null;
      }
    },

    loadKml(text){
      if(this.leafletMap != null){
        const parser = new DOMParser();
        this.new_kml = parser.parseFromString(text, 'text/xml');
        this.layerKml = new L.KML(this.new_kml);
        this.leafletMap.addLayer(this.layerKml);
      }
    },
    fetchEventComments(eventId) {
      this.axios
        .get("apidev/api/comments_events/" + eventId, this.config)
        .then(response => {
          this.eventComments = response.data;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    selectEvent(event) {
      this.currentEvent = event;
      this.center = [event.lat, event.lng];
      this.fetchEventComments(event.id);
      this.showPolygonInMap();
    },
    openSendModal(eventId, name) {
      this.eventId = eventId;
      this.eventName = name;
      this.showSendModal = true;
    },
    closeSendModal(type) {
      if (type === "dismiss") {
        this.showSendModal = false;
      } else {
        this.fetchEvents();
        this.search = "";
        this.showSendModal = false;
        this.showingSentDialog = true;
      }
    },
    closeModal(type, events) {
      if (type === "dismiss") {
        this.showEventModal = false;
      } else {
        this.fetchEvents();
        this.search = "";
        this.showEventModal = false;
        if (this.modalAction === "add") {
          if (events.length > 0) {
            this.showDuplicateEvents = true;
            this.duplicateEvents = events;
          }
        }
        this.showingSuccess = true;
      }
    },
    closeCommentsModal() {
      this.showCommentsModal = false;
    },
    deleteEvent() {
      this.axios
        .delete(
          "apidev/api/events/" + this.currentEvent.id,
          this.config
        )
        .then(response => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Eventos",
              action: "Eliminación de un evento",
              observation: this.currentEvent.nombre,
              email: localStorage.getItem("email")
            },
            this.config
          );
        })
        .then(response => {
          this.currentEvent = {};
          this.fetchEvents();
          this.search = "";
          this.showingConfirm = false;
          this.showingSuccessDelete = true;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    openAddModal() {
      this.modalEvent = {
        imagen: ""
      };
      this.modalAction = "add";
      this.showEventModal = true;
    },
    openEditModal() {
      this.modalEvent = Object.assign({}, this.currentEvent);
      this.aux_modalEvent = Object.assign({}, this.currentEvent);
      this.modalAction = "edit";
      this.showEventModal = true;
    },
    fetchCategories() {
      this.axios
        .get("apidev/api/config/categories/events", this.config)
        .then(response => {
          this.eventCategories = response.data.categories;
          this.colors = this.getEventCategoryColors(this.eventCategories);

          this.fetchEvents();
        });
    },
    openCalendar() {
      this.showingCalendar = true;
    },
    closeCalendar() {
      this.showingCalendar = false;
    },
    loadDefaultImg(event) {
      event.target.src = require("@/assets/default-image-sm.jpg");
    },
    updateComments() {
      this.fetchEventComments(this.currentEvent.id);
    },
    closeDuplicateEvents() {
      this.showDuplicateEvents = false;
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    },
    getEventCategoryColors(eventCategories) {
      let categoryColors = [];
      let colors = palette("mpn65", this.eventCategories.length);
      eventCategories.forEach((eventCategory, index) => {
        let categoryColor = {
          name: eventCategory.name,
          color: colors[index]
        };

        categoryColors.push(categoryColor);
      });

      return categoryColors;
    }
  },
  computed: {
    filteredEvents() {
      return this.events
        .filter(event => {
          return (
            (event.nombre.toLowerCase().includes(this.search.toLowerCase()) ||
              event.lugar.toLowerCase().includes(this.search.toLowerCase())) &&
            (this.categoryFilter === "-1" ||
              event.category_id === this.categoryFilter.toString())
          );
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
              return -1;
            }
            if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
              return 1;
            }
            return 0;
          } else {
            if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
              return -1;
            }
            if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
              return 1;
            }
            return 0;
          }
        });
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
